module.exports = __webpack_public_path__ + "img/o-samba-vai-dominar-o-mundo.c3af64bb.svg";